import { atomWithLoadable } from 'lib/atoms';
import request from 'lib/request';
import type { NonIntersectingExplicitAssignmentsResponse } from './types';

export const [
  nonIntersectingExplicitAssignmentsAtom,
  nonIntersectingExplicitAssignmentsLoadableAtom,
] = atomWithLoadable(async () => {
  const response =
    await request.get<NonIntersectingExplicitAssignmentsResponse>(
      '/admin/non_intersecting_explicit_assignments'
    );
  if ('error' in response) {
    throw new Error(response.error);
  }
  return response;
});
